// Imports
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import {
  Card,
  Stack,
  Paper,
  Avatar,
  Button,
  Container,
  Typography,
  IconButton,
  TablePagination,
  ListItemIcon,
  Box,
  TextField,
  Tooltip,
  InputAdornment,
} from '@mui/material';

import Label from '../components/label';
import Iconify from '../components/iconify';
import MUIDataTable from 'mui-datatables';
import { AlertDialog } from '../utils/dealog/diloag';
import { showSuccess, showError } from '../utils/toast';
import {
  useGetUseListApiQuery,
  useUserSearchApiMutation,
} from '../redux/services/user/User';
import { useActivateAccountApiMutation } from '../redux/services/common/Common';

const columns = [
  {
    name: 'firstName',
    label: 'FirstName',
    options: {
      filter: true,
      sort: true,
    },

  },
  {
    name: 'email',
    label: 'Email',
    options: {
      filter: true,
      sort: true,
    },

  },
  {
    name: 'mobile',
    label: 'Mobile',
    options: {
      filter: true,
      sort: true,
    },

  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: true,
      sort: true,
    },

  },
];

function UserFirstName({ firstName, id, lastName }) {
  return (
    <Button variant="text" component={RouterLink} to={`/user-orders/${id}`}>
      {firstName} {lastName}
    </Button>
  );
}



function UserMobileNo({ mobileNo }) {
  return <Typography variant="body1">{mobileNo}</Typography>;
}

function UserEmail({ email }) {
  return <Typography variant="body1">{email}</Typography>;
}

function UserActive({ onActive, user }) {
  return (
    <Tooltip title="Active">
      <Button onClick={() => onActive(user)}>
        <ListItemIcon>
          <Iconify icon="bxs:user-check" width={24} height={24} color="green" />
        </ListItemIcon>
      </Button>
    </Tooltip>
  );
}

function UserDeaActive({ onDeaActive, user }) {
  return (
    <Tooltip title="DeActive">
      <Button onClick={() => onDeaActive(user)}>
        <ListItemIcon>
          <Iconify icon="bxs:user-x" width={24} height={24} color="red" />
        </ListItemIcon>
      </Button>
    </Tooltip>
  );
}

export default function UserPage() {
  // user ApiRedux
  const { data: userListData, isLoading } = useGetUseListApiQuery();
  const [activeUser, ActiveUser] = useActivateAccountApiMutation();
  const [userSearch] = useUserSearchApiMutation();

  const [loadData, setLoadData] = useState(false);
  const [userListRow, setUserListRow] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchByMobile, setSearchByMobile] = useState('');
  const [searchByName, setSearchByName] = useState('');

  const [showUserActivete, setShowUserActivete] = useState(false);
  const userActiveteMassege = useRef();
  const userActiveteTitel = useRef();
  const userActivete = useRef();

  const onCloseUserActivete = () => {
    setShowUserActivete(false);
  };

  const userList = () => {
    if (userListData && userListData?.list) {
      const data = [];
      userListData?.list.forEach((item) => {
        const actionButtons = item.is_active ? (
          <UserDeaActive user={item} onDeaActive={onShowUserDeactivete} />
        ) : (
          <UserActive user={item} onActive={onShowUserActivete} />
        );
        data.push({
          firstName: (
            <UserFirstName firstName={item.first_name} lastName={item.last_name} id={item.accountId} />
          ),
          mobile: <UserMobileNo mobileNo={item.mobile} />,
          email: <UserEmail email={item.email} />,
          status: actionButtons,
        });
        setLoadData(true);
      });
      setUserListRow(data);
      setTotalPage(userListData?.total);
      setCurrentPage(userListData?.current);
    }
  };

  useEffect(() => {
    userList();
  }, [loadData, searchByMobile, searchByName]);

  const onUserSearch = async (mobile, name) => {
    const search = {
      mobile: mobile,
      name: name,
    };
    try {
      const userSearchResult = await userSearch(search);
      if (userSearchResult && userSearchResult.data.list) {
        const data = [];
        userSearchResult.data.list.forEach((item) => {
          const actionButtons = item.is_active ? (
            <UserDeaActive user={item} onDeaActive={onShowUserDeactivete} />
          ) : (
            <UserActive user={item} onActive={onShowUserActivete} />
          );
          data.push({
            firstName: (
              <UserFirstName firstName={item.first_name} lastName={item.last_name} id={item.accountId} />
            ),
            mobile: <UserMobileNo mobileNo={item.mobile} />,
            email: <UserEmail email={item.email} />,
            status: actionButtons,
          });
        });
        setUserListRow(data);
        console.log('search', data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadData(true);
    }
  };

  const onShowUserActivete = (user) => {
    userActivete.current = user;
    userActiveteMassege.current = `Activate ${user.first_name} ${user.last_name}`;
    userActiveteTitel.current = 'Are you sure to Activate this user?';
    setShowUserActivete(true);
  };

  const onShowUserDeactivete = (user) => {
    userActivete.current = user;
    userActiveteMassege.current = `Deactivate ${user.first_name} ${user.last_name}`;
    userActiveteTitel.current = 'Are you sure to Deactivate this user?';
    setShowUserActivete(true);
  };

  const onActivateUser = async () => {
    const status = userActivete.current.is_active ? 'D' : 'A';
    const body = {
      account_id: userActivete.current.accountId,
      status: status,
    };
    const result = await activeUser(body);
    console.log("Active", result)
    setLoadData(true);
    setShowUserActivete(false);
  };

  useEffect(() => {
    if (ActiveUser.isSuccess) {
      showSuccess('User activation/deactivation successful');
      ActiveUser.reset();
    }
    if (ActiveUser.isError) {
      showError(ActiveUser.error.data.msg);
      ActiveUser.reset();
    }
  }, [ActiveUser]);

  const options = {
    filterType: 'dropdown',
    selectableRows: 'multiple',
    responsive: 'vertical',
    serverSide: true,
    count: totalPage,
    page: currentPage,
    onTableChange: (action, tableState) => {
      if (action === 'changePage') {
        setCurrentPage(tableState.page + currentPage);
      }
    },
  };

  const handleSearchMobile = (e) => {
    const value = e.target.value;
    setSearchByMobile(value);

    const is10DigitNumber = /^\d{10}$/.test(value);

    if (is10DigitNumber) {
      onUserSearch(`+91${value}`, searchByName);
    } else if (value.trim() === '') {
      setSearchByMobile('');
      userList();
    } else {
      onUserSearch(value, searchByName);
    }
  };

  const handleSearchName = (e) => {
    const value = e.target.value;
    setSearchByName(value);
    if (value.trim() === '') {
      setSearchByName('');
      userList();
    } else {
      onUserSearch(searchByMobile, value);
    }
  };

  return (
    <>
      <Helmet>
        <title>User | Minimal UI</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            New User
          </Button>
        </Stack>
        <Card>
          <Box sx={{ flexGrow: 1, margin: '30px' }}>
            <Grid container spacing={1} sx={{ display: 'flex', justifyContent: 'end' }}>
              <Grid item xs={3}>
                <Box>
                  <TextField
                    id="outlined-basic"
                    label="Search By MobileNo"
                    variant="outlined"
                    size="small"
                    value={searchByMobile}
                    onChange={handleSearchMobile}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton aria-label="search">
                            <SearchIcon sx={{ color: 'blue' }} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box>
                  <TextField
                    id="outlined-basic"
                    label="Search By Name"
                    variant="outlined"
                    size="small"
                    value={searchByName}
                    onChange={handleSearchName}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton aria-label="search">
                            <SearchIcon sx={{ color: 'blue' }} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
        <br />
        <br />
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        ) : (
          <Card>
            <MUIDataTable title={'User'} data={userListRow} columns={columns} options={options} />
          </Card>
        )}
      </Container>

      <AlertDialog open={showUserActivete} message={userActiveteMassege} title={userActiveteTitel} onCancel={onCloseUserActivete} onOkey={onActivateUser} />
    </>
  );
}
